module.exports = __webpack_public_path__ + "img/icon-radar.99e68fb8.svg";